import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosError,
} from "axios";
import { getAccessToken } from "../services/cookieService";
import { handle403Redirect } from "utils/authHandlers";
import { environment } from "../environments/environment";

const BASE_URL = environment.ELVA_HOST_URL;
console.log("BASE_URL: ", BASE_URL);
const version = environment.ELVA_API_VERSION;
console.log("version: ", version);

const aiInterceptor: AxiosInstance = axios.create({
  baseURL: `${BASE_URL}/api/${version}`,
});

aiInterceptor.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAccessToken();
    if (token) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }

    const isFormData = config.data instanceof FormData;
    if (!isFormData) {
      config.headers.set("Content-Type", "application/json");
    }

    // Add device fingerprint
    const deviceFingerprint = localStorage.getItem("deviceFingerprint");
    if (deviceFingerprint) {
      config.headers.set("X-Device-Fingerprint", deviceFingerprint);
    }

    return config;
  },
  (error: AxiosError) => Promise.reject(error),
);

aiInterceptor.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 403) {
      console.warn("Unauthorized access - token might be invalid");
      handle403Redirect();
    } else if (error.response && error.response.status === 429) {
      console.warn("Rate limit exceeded:", error.response.data);
    }
    return Promise.reject(error);
  },
);

export default aiInterceptor;
